import React, { useEffect, useState } from 'react'
import classNames from 'classnames'
import { GxIcon } from '@garpix/garpix-web-components-react'
import { IPropsUploadPhoto } from '../interface'
import { editIcon, plusIcon } from '@/images'
import { ACCEPT_FILES_IMAGES } from '@/const'
import style from '../styles/upload.module.scss'

const UploadPhoto = ({
  className = '',
  name = '',
  photo = null,
  onBlur = () => {},
  onChange = () => {}
}: IPropsUploadPhoto): React.ReactElement => {
  const [photoSrc, setPhotoSrc] = useState<any>(photo)

  useEffect(() => {
    if (photo !== null) {
      const objectUrl = URL.createObjectURL(photo)
      setPhotoSrc(objectUrl)
    } else {
      setPhotoSrc(null)
    }
  }, [photo])

  const accept = ACCEPT_FILES_IMAGES.join(', ')

  if (photoSrc === null) {
    return (
      <label
        className={classNames({
          [style.empty__label]: true,
          [className]: Boolean(className)
        })}
      >
        <input
          accept={accept}
          className='hidden'
          name={name}
          type='file'
          onBlur={onBlur}
          onInput={onChange}
        />
        <span className={style.empty__text}>
          <GxIcon src={plusIcon} className={style.empty__icon} />
          Загрузить фото
        </span>
      </label>
    )
  } else {
    return (
      <div
        className={classNames({
          [style.photo]: true,
          [className]: Boolean(className)
        })}
      >
        <img
          src={photoSrc}
          width='415px'
          height='415px'
          alt='Фото работы'
          className={style.photo__image}
        />

        <label className={style.photo__label}>
          <input
            accept={accept}
            className='hidden'
            name={name}
            type='file'
            onBlur={onBlur}
            onInput={onChange}
          />
          <GxIcon src={editIcon} className={style.photo__icon} />
        </label>
      </div>
    )
  }
}

export default UploadPhoto
